document.querySelectorAll('.qovo-specs-tabs').forEach(function (root) {
  var triggers = root.querySelectorAll('[data-tab-trigger]');

  triggers.forEach(function (trigger) {
    trigger.addEventListener('click', function () {
      var index = trigger.getAttribute('data-tab-trigger');

      root.querySelectorAll('[data-tab-trigger]').forEach(function (btn) {
        var active = btn.getAttribute('data-tab-trigger') === index;
        btn.classList.toggle('is-active', active);
        btn.setAttribute('aria-selected', active ? 'true' : 'false');
      });

      root.querySelectorAll('[data-tab-panel]').forEach(function (panel) {
        panel.classList.toggle('is-active', panel.getAttribute('data-tab-panel') === index);
      });
    });
  });
});
